import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseAnpPricesProps<T> = {
  filters?: {
    reportId?: string;
    productId?: string | number;
    geoType?: string;
    geoCityId?: string;
    geoStateId?: string;
    geoRegionId?: string;
    page?: number;
  };
  mapper?: (data: any) => T;
};

export const useAnpPrices = <T,>({
  filters: {
    reportId,
    productId,
    geoType,
    geoCityId,
    geoStateId,
    geoRegionId,
    page,
  } = {},
  mapper = Mapper.default<T>(),
}: UseAnpPricesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['anpPrices', reportId, productId, geoType, geoCityId, geoStateId, geoRegionId, page],
    enabled: Boolean(reportId && geoType),
    queryFn: async () => {
      const queryParams = {
        page,
        'q[report_id_eq]': reportId,
        'q[product_id_eq]': productId,
        'q[geo_type_eq]': geoType,
        'q[geo_city_id_eq]': geoCityId,
        'q[geo_state_id_eq]': geoStateId,
        'q[geo_region_id_eq]': geoRegionId,
      };

      return privateAxios.get('/anp/prices', { params: queryParams });
    },
    select: (response: { data: { data: any[]; meta: MetaResponse; }; }) => ({
      data: mapper(response?.data?.data ?? []),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
